import { Box, Typography } from "components";

const ErrorMessageRender = (props: {
  errorsObj: Record<string, { error: boolean; subs: string[] }>;
  t: (key: string, options?: any) => string;
}) => {
  const { errorsObj = {}, t } = props;

  const errorMessagesLabel =
    t(
      "client.error.masterInsurancePlanPublishedValidationFailed.errorMessages"
    ) || "Error Messages";

  return (
    <Box width="100%" mt="16px">
      <Typography variant="body1">{errorMessagesLabel}</Typography>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        paddingLeft="16px"
      >
        <ul
          style={{
            padding: "16px 0px",
            margin: 0,
            listStylePosition: "inside",
          }}
        >
          {["detail", "customPackage", "premiums", "conditions"].map((key) => {
            const value = errorsObj[key];
            if (value && value.error) {
              if (value.subs && value.subs.length > 0) {
                return value.subs.map((sub: string, idx: number) => (
                  <li key={`${key}-${idx}`} style={{ marginBottom: "4px" }}>
                    <Typography variant="Body/14">
                      {`${
                        t(
                          `client.error.masterInsurancePlanPublishedValidationFailed.${key}`
                        ) || key
                      }: ${t(sub) || sub}`}
                    </Typography>
                  </li>
                ));
              } else {
                return (
                  <li key={key} style={{ marginBottom: "4px" }}>
                    <Typography variant="Body/14">
                      {t(
                        `client.error.masterInsurancePlanPublishedValidationFailed.${key}`
                      ) || key}
                    </Typography>
                  </li>
                );
              }
            }
            return null;
          })}
        </ul>
      </Box>
    </Box>
  );
};

export default ErrorMessageRender;
